/* ++++++++++ --------------- HELP PAGE : STYLES --------------- ++++++++++ */
export default {
  '@global': {
    '.helpfulLinks': {
      'margin': '20px 50px'
    }
  }
}